/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-09-17 21:03:59
 */
import sensors, { sensorsRole } from './sensors'

export const canRemoveWatermark = (photo) => {
  return (
    photo.get('sourceType') !== 1 &&
    photo.get('sourceType') !== 4 &&
    photo.get('hasWatermark') &&
    photo.get('mediaType') === 0
  )
}

/**
 * 获取异常照片的标签信息
 * @param {number} sourceType - 照片来源类型
 * @returns {Object|null} 返回包含type和text的对象，如果没有匹配的类型则返回null
 */
export const getAbnormalPhotoTagInfo = (sourceType) => {
  const tagMap = {
    // "假"类型
    13: { type: 'fake', text: '非真实拍摄，照片验证为假' },
    12: { type: 'fake', text: '非正版软件拍照，照片验证为假' },
    14: { type: 'fake', text: '非正版软件拍照，照片验证为假' },
    // "!"类型
    15: { type: 'warning', text: '该照片拍摄时的App版本过低' },
    11: { type: 'warning', text: '使用虚拟定位，不确保地点真实' },
    10: { type: 'warning', text: '非官方版本拍照，不确保时间地点真实' },
    8: { type: 'warning', text: '不在管理员限定拍照地点' },
    3: { type: 'warning', text: '非成员常用手机拍摄' },
    2: { type: 'warning', text: '非成员常用手机拍摄非本人拍摄' },
    1: { type: 'warning', text: '非今日水印相机拍摄原图，不确保时间地点真实' }
  }
  return tagMap[sourceType] || null
}

/**
 * 检查照片是否为异常照片
 * @param {Object} photo - 照片对象
 * @returns {boolean} 是否为异常照片
 */
export const isAbnormalPhoto = (photo) => {
  const sourceType = photo.get('sourceType')
  return getAbnormalPhotoTagInfo(sourceType) !== null
}

/**
 * 用于埋点上报的内容文案
 * @param {number} sourceType - 照片来源类型
 * @returns {string} 用于埋点上报的内容文案
 */
export const getSensorContent = (sourceType) => {
  const contentMap = {
    15: '版本过低',
    14: '音视频判断假照片(T+2更新数据)',
    13: '验真为假（不含-8003）',
    12: '范围更广的破解包',
    11: '虚拟定位',
    10: '校验较强的破解包（只有feature=6的）',
    8: '非指定地点',
    3: '非常用设备',
    2: '非本人拍摄',
    1: '非今日水印相机'
  }
  return contentMap[sourceType] || ''
}

/**
 * 辅助函数：从普通对象获取嵌套值
 * @param {Object} obj - 普通对象
 * @param {Array} path - 路径数组，如 ['times', 0]
 * @returns {*} 返回的值
 */
export const getIn = (obj, path) => {
  if (!obj) return undefined
  let result = obj
  for (const key of path) {
    if (result === undefined || result === null) {
      return undefined
    }
    result = result[key]
  }
  return result
}

/**
 * 通用的曝光埋点函数
 * @param {Array} photos - 照片数组（可以是Immutable格式或普通对象格式）
 * @param {Object} params - 埋点参数
 * @param {string} params.groupID - 团队ID
 * @param {string} params.myRole - 用户角色
 * @param {Object} params.queryFilter - 查询过滤器（Immutable格式或普通对象格式）
 */
export const trackExposureSensorEvent = (
  photos,
  { groupID, myRole, queryFilter }
) => {
  // 筛选出假照片或异常照片
  const fakeOrAbnormalPhotos = photos.filter((photo) => {
    const sourceType = photo.sourceType
    const tagInfo = getAbnormalPhotoTagInfo(sourceType)
    return tagInfo && (tagInfo.type === 'fake' || tagInfo.type === 'warning')
  })

  if (fakeOrAbnormalPhotos.length > 0) {
    // 构建list1数组
    const list1 = fakeOrAbnormalPhotos.map((photo) => ({
      photoid: photo.seq,
      sourcetypedetail: getSensorContent(photo.sourceType),
      user_id: photo.userID
    }))

    // 获取筛选时间 - 兼容 Immutable 和普通对象格式
    const startDate = getIn(queryFilter, ['times', 0])
    const endDate = getIn(queryFilter, ['times', 1])

    sensors.track('workgroup_b4343_c7638_exposure', {
      list1,
      endDate: endDate ? endDate.format('YYYY-MM-DD') : null,
      startDate: startDate ? startDate.format('YYYY-MM-DD') : null,
      role: sensorsRole(myRole),
      groupID,
      track_sign:
        'aworkgroup.b4343.c7638.exposure.workgroup_b4343_c7638_exposure',
      requirement_id: 276
    })
  }
}
